// extracted by mini-css-extract-plugin
export default {"flash":"dashboard-widget-panel_flash__F6GAF","widgetPanel":"dashboard-widget-panel_widgetPanel__IdRxP","widgetPanelHeader":"dashboard-widget-panel_widgetPanelHeader__AXrdn"};